import {
  createEvoClient,
  getEligibleDevices,
  getTradeInPublicDomainConfiguration,
  isConsumerEligibleForTradeIn,
} from "@jti/evo-client";
import { getConfig, keysToCamelCase } from "@jti/fe-common";
import type { TradeInConfiguration, TradeInEligibleDevices } from "@jti/rest-api-types";

import { getUser } from "../../utils";

export class TradeInApi {
  readonly name = "TradeInApi";
  private readonly client;
  private readonly user;

  constructor() {
    const config = getConfig();
    this.user = getUser();

    this.client = createEvoClient({
      baseUrl: config.EVO_DOMAIN,
      tenantToken: config.EVO_TENANT,
      recaptchaId: config["X-RECAPTCHA-ID"],
      ciamToken: this.user.ciam_token,
      throwOnError: true,
    });
  }

  async getConfiguration(): Promise<TradeInConfiguration> {
    const { data } = await getTradeInPublicDomainConfiguration({
      client: this.client,
      throwOnError: true,
    });

    return keysToCamelCase(data);
  }

  async getTradeInEligibility() {
    if (!this.user.uuid) {
      throw new Error("user id not defined");
    }

    const { data } = await isConsumerEligibleForTradeIn({
      path: {
        uuid: this.user.uuid,
      },
      client: this.client,
      throwOnError: true,
    });

    return keysToCamelCase(data);
  }

  async getTradeInDevices(): Promise<TradeInEligibleDevices> {
    const { data } = await getEligibleDevices({
      client: this.client,
      throwOnError: true,
    });

    return keysToCamelCase(data);
  }
}
